import { Collapse, Tag, Table } from 'antd';
import { useTable } from '@refinedev/antd';
import { useTranslate } from '@refinedev/core';
import dayjs from 'dayjs';

import apiEndpoint from 'core/common/apiEndPoints';

const RuleGroupView = ({ group, pageType, isPublished }) => {
  const t = useTranslate();

  const resourceBase =
    pageType === 'Show' && isPublished
      ? apiEndpoint.rules
      : apiEndpoint.rulesDraft;

  const { tableProps } = useTable({
    resource: `${resourceBase}/?rule_group=${group?.unique_id}`,
    pagination: { pageSize: 10, mode: 'server' },
  });

  const rawData: any = tableProps?.dataSource;
  const rules = Array.isArray(rawData?.results) ? rawData.results : [];
  const total = rawData?.count ?? 0;

  const columns = [
    {
      dataIndex: 'rule_name',
      render: (_, record, index) => {
        const current = (tableProps?.pagination as any)?.current ?? 1;
        const pageSize = (tableProps?.pagination as any)?.pageSize ?? 10;
        return (
          <div className="flex items-center gap-2">
            <span>{(current - 1) * pageSize + index + 1}</span>
            <span>{record.rule_name}</span>
          </div>
        );
      },
    },
  ];

  return (
    <div className="border rounded-lg">
      <Collapse
        accordion
        bordered
        expandIconPosition="end"
        className="no-padding-panel rule-view-collapse"
        defaultActiveKey="info"
      >
        <Collapse.Panel header={t('ruleGroup.groupInformation')} key="info">
          <div className="grid grid-cols-2 gap-y-4 gap-x-4 p-4">
            <div>
              <div className="text-xs font-semibold uppercase text-gray-400 pb-1">
                {t('common.name')}
              </div>
              <div className="text-base">{group?.rule_group_name}</div>
            </div>
            <div>
              <div className="text-xs font-semibold uppercase text-gray-400 pb-1">
                {t('common.type')}
              </div>
              <div className="text-base">{group?.rule_type}</div>
            </div>
            <div>
              <div className="text-xs font-semibold uppercase text-gray-400 pb-1">
                {t('common.dateRange')}
              </div>
              <div className="text-base">
                {dayjs(group?.rule_group_start_date).format('YYYY-MM-DD')} -{' '}
                {dayjs(group?.rule_group_end_date).format('YYYY-MM-DD')}
              </div>
            </div>
            <div>
              <div className="text-xs font-semibold uppercase text-gray-400 pb-1">
                {t('common.status')}
              </div>
              <Tag color={group?.rule_group_is_active ? 'green' : 'default'}>
                {group?.rule_group_is_active
                  ? t('rules.ruleActive')
                  : t('rules.ruleInactive')}
              </Tag>
            </div>
          </div>
        </Collapse.Panel>

        <Collapse.Panel
          header={t('ruleGroup.rulesInGroup', { count: total })}
          key="rules"
        >
          <div className="group-view-table-wrapper">
            <Table
              {...tableProps}
              dataSource={rules}
              columns={columns}
              rowKey="unique_id"
              showHeader={false}
              className="row-card-table group-view-table"
              size="small"
            />
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default RuleGroupView;
